import React, { useState, useEffect } from "react";
import {
	Table,
	Button,
	Modal,
	Form,
	Input,
	Row,
	Col,
	Space,
	Select,
	Tooltip,
	Card,
	notification,
	Badge,
	InputNumber,
} from "antd";
import { UsergroupAddOutlined, EditOutlined } from "@ant-design/icons";
import DefaultLayout from "../../components/layout/DefaultLayout";
import Header from "../../components/header";
import approverService from "../../services/approver";
import { useMediaQuery } from "react-responsive";
import userService from "../../services/user";
// import FormListComponent from "./../../components/serviceDeskFormList";
import ReminderGroupComponent from "./../../components/reminderGroup";
import taskReminder from "../../services/taskReminder";
import formService from "../../services/form";

const { Option } = Select;

const TaskNotification = () => {
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [edit, setEdit] = useState(null);
	const [form] = Form.useForm();

	const [formNames, setformNames] = useState([]);
	const [data, setData] = useState([]);
	const [userData, setUserData] = useState({});

	const [loading, setLoading] = useState(false);

	const [currentPage, setCurrentPage] = useState(1);
	const [totalDataCount, setTotalDataCount] = useState(0);
	const [itemsPerPage, setItemsPerPage] = useState(15);
	const [users, setUsers] = useState(null);
	const [remindersData, setRemindersData] = useState([
		{ approver: undefined, permission: 1 },
	]);

	const getUsers = async () => {
		let response;
		response = await userService.getUsers();
		setUsers(response.data);
	};
	const getForms = async () => {
		try {
			const forms = await formService.getAllForms();
			setformNames(forms);
		} catch (error) {
			console.error("Error getting forms:", error);
			return [];
		}
	};
	useEffect(() => {
		getUsers();
		getForms();
	}, []);

	const showModal = () => {
		setIsModalVisible(true);
	};

	const handleCancel = () => {
		setIsModalVisible(false);
		setEdit(null);
		form.resetFields();
	};

	const handleEdit = (record) => {
		console.log("Edit record:", record);

		const children = record.children || [];

		const reminders = children.map((child, index) => {
			return {
				task_reminder_group_id: child.group_id || child.group?.id,
				reminder_days: child.reminder_days,
				sequence_no: child.sequence_no,
			};
		});

		const formValues = {
			name: record.form_id,
		};

		children.forEach((child, index) => {
			formValues[`task_reminder_group_id_${index}`] = child.group_id;
			formValues[`reminder_days_${index}`] = child.reminder_days;
			formValues[`sequence_no_${index}`] = child.sequence_no;
		});

		form.setFieldsValue(formValues);
		setRemindersData(reminders);
		setEdit(record);
		setIsModalVisible(true);
	};

	const getReminders = async (page = 1, itemsPerPage) => {
		setLoading(true);
		try {
			const response = await taskReminder.getReminders(page, itemsPerPage);
			console.log(" get response");
			console.log(response.data);

			setData(response.data);
			// setCurrentPage(page);
			// setTotalDataCount(response.meta.total);
			// setItemsPerPage(response.meta.per_page);
			setLoading(false);
			// const mappedUserData = response.map((approver) => {
			//   if (approver.id && approver.users) {
			//     return { [approver.id]: approver.users };
			//   }
			//   return {};
			// });

			// setUserData(Object.assign({}, ...mappedUserData));
		} catch (error) {
			console.log(" get response error ");
			console.log(error);
		}
	};

	useEffect(() => {
		getReminders();
	}, []);

	const onFinish = async (values) => {
		const reminders = remindersData.map((_, index) => ({
			task_reminder_group_id: values[`task_reminder_group_id_${index}`],
			reminder_days: values[`reminder_days_${index}`],
			sequence_no: values[`sequence_no_${index}`],
		}));

		const payload = {
			form_id: values.name,
			reminders,
		};

		try {
			setLoading(true);

			const response = edit
				? await taskReminder.updateReminder(edit.form_id, payload)
				: await taskReminder.postReminder(payload);
			if (response?.success) {
				notification.success({
					message: edit ? "Reminder Updated" : "Reminder Added",
					description: response.message || "Operation completed successfully.",
				});

				setIsModalVisible(false);
				setEdit(null);
				form.resetFields();
				getReminders(currentPage);
			} else {
				notification.error({
					message: "Unexpected Error",
					description:
						response.message || "Something went wrong. Please try again.",
				});
			}
		} catch (error) {
			console.error("Submit error:", error);
			notification.error({
				message: "Error",
				description: error?.response?.data?.message || "Something went wrong",
			});
		} finally {
			setLoading(false);
		}
	};

	const columns = [
		{
			title: "Form Name",
			dataIndex: "name",
			key: "form_name",
			// render: (text) => <strong>{text}</strong>,
		},
		{
			title: "Group Name",
			dataIndex: "group_names",
			key: "group_name",
			render: (text, record) =>
				record.children ? text : <strong>{text}</strong>, // parent: comma-separated
		},

		{
			title: "Reminder Days",
			dataIndex: "reminder_days",
			key: "reminder_days",
		},
		{
			title: "Sequence No",
			dataIndex: "sequence_no",
			key: "sequence_no",
		},
		{
			title: "Actions",
			key: "actions",
			render: (_, record) =>
				!record.children ? null : (
					<Space>
						<div
							onClick={() => handleEdit(record)}
							style={{ cursor: "pointer" }}
						>
							<EditOutlined />
						</div>
					</Space>
				),
		},
	];

	const removeApproversAndPermissions = (index) => {
		setRemindersData((prevData) => prevData.filter((_, i) => i !== index));
	};

	const renderUsersandDays = () => {
		return remindersData.map((data, index) => (
			<div key={`approver-permission-${index}`}>
				<Card
					size='small'
					title={
						<span>
							<Badge color='#2d77fa' count={index + 1} /> Reminder{" "}
						</span>
					}
					className='mb-10'
				>
					<Row gutter={[12, 12]}>
						<Col span={16}>
							<Form.Item
								shouldUpdate={(prev, curr) =>
									prev[`task_reminder_group_id_${index}`] !==
									curr[`task_reminder_group_id_${index}`]
								}
								noStyle
							>
								{({ getFieldValue, setFieldsValue }) => (
									<Form.Item
										name={`task_reminder_group_id_${index}`}
										label={`Group ${index + 1}`}
										rules={[{ required: true, message: "Please select group" }]}
									>
										<ReminderGroupComponent
											value={getFieldValue(`task_reminder_group_id_${index}`)}
											onChange={(val) => {
												setFieldsValue({
													[`task_reminder_group_id_${index}`]: val,
												});
											}}
										/>
									</Form.Item>
								)}
							</Form.Item>
						</Col>

						<Col span={4}>
							<Form.Item
								name={`reminder_days_${index}`}
								label={`Days ${index + 1}`}
								rules={[
									{ required: true, message: "Please enter number of days" },
								]}
							>
								<InputNumber
									min={1}
									max={255}
									style={{ width: "100%" }}
									size='large'
								/>
							</Form.Item>
						</Col>

						<Col span={4}>
							<Form.Item
								name={`sequence_no_${index}`}
								label={`Sequence No ${index + 1}`}
								initialValue={index + 1}
								rules={[
									{ required: true, message: "Sequence Number is required" },
								]}
							>
								<Input size='large' readOnly />
							</Form.Item>
						</Col>
					</Row>
				</Card>
				{index > 0 && (
					<div className='textRight mb-10'>
						<Button
							type='dashed'
							onClick={() => removeApproversAndPermissions(index)}
						>
							Remove
						</Button>
					</div>
				)}
			</div>
		));
	};

	const handleAddApproversAndPermissions = () => {
		setRemindersData((prevData) => [
			...prevData,
			{ approver: undefined, permission: 1 },
		]);
	};

	const handleAddApproversAndPermissionsForNewRecord = () => {
		setRemindersData((prevData) => [{ approver: undefined, permission: 1 }]);
	};

	const formattedData = data.map((form) => {
		const groupNames = form.task_reminders
			.map((r) => r.group?.name)
			.filter(Boolean)
			.join(", ");

		return {
			key: form.id,
			name: form.name,
			form_id: form.form_id || form.id,
			group_names: groupNames || "-",
			children: form.task_reminders.map((reminder) => ({
				key: `reminder-${reminder.id}`,
				reminder_days: reminder.reminder_days,
				sequence_no: reminder.sequence_no,
				name: reminder.group?.name || "-",
				group_id: reminder.group?.id || "",
			})),
		};
	});
	return (
		<DefaultLayout>
			<Row gutter={[24, 24]}>
				<Col span={24}>
					<Header
						icon={<UsergroupAddOutlined />}
						title='Task Notification'
						right={
							<Button
								className='btn-blue'
								type='primary'
								onClick={() => {
									showModal();
									handleAddApproversAndPermissionsForNewRecord();
								}}
							>
								Add Reminder
							</Button>
						}
					/>
				</Col>
			</Row>

			<Table
				columns={columns}
				dataSource={formattedData}
				loading={loading}
				pagination={{
					total: totalDataCount,
					current: currentPage,
					pageSize: itemsPerPage,
					onChange: (page, pageSize) => getReminders(page, pageSize),
				}}
				scroll={{ x: 800 }}
			/>

			<Modal
				style={{ top: 14 }}
				title={
					edit ? "Edit Task Reminder Scheduler" : "Add Task Reminder Scheduler"
				}
				open={isModalVisible}
				onCancel={handleCancel}
				footer={null}
				width={{
					xs: "90%",
					sm: "80%",
					md: "70%",
					lg: "70%",
					xl: "70%",
					xxl: "70%",
				}}
			>
				<Form
					form={form}
					onFinish={onFinish}
					layout='vertical'
					className='mt-20'
				>
					{edit ? (
						<div className='mb-20'>
							<h2>{edit.name}</h2>
						</div>
					) : (
						<div className='mb-20'>
							<h2>Form</h2>
						</div>
					)}
					{renderUsersandDays()}
					<div
						style={{ display: "flex", justifyContent: "space-between" }}
						className='mb-20'
					>
						<Button type='dashed' onClick={handleAddApproversAndPermissions}>
							Add new group
						</Button>
					</div>
					<Form.Item>
						<Button type='primary' htmlType='submit' loading={loading}>
							{edit ? "Save Changes" : "Add Reminder"}
						</Button>
					</Form.Item>
				</Form>
			</Modal>
		</DefaultLayout>
	);
};

export default TaskNotification;
